(function () {
  var form = document.querySelector('[data-ndis-form]');
  if (!form) return;

  var emailWrap = form.querySelector('[data-ndis-email-wrap]');
  var email = form.querySelector('[data-ndis-email]');
  var agencyWrap = form.querySelector('[data-ndis-agency-wrap]');
  var agency = form.querySelector('[data-ndis-agency]');
  var customerEmailWrap = form.querySelector('[data-ndis-customer-email-wrap]');
  var customerEmail = form.querySelector('[data-ndis-customer-email]');
  var replacementWrap = form.querySelector('[data-ndis-replacement-wrap]');
  var replacement = form.querySelector('[data-ndis-replacement]');
  var phone = form.querySelector('[data-ndis-phone]');
  var steps = form.querySelector('[data-ndis-self-steps]');
  var quoteNote = form.querySelector('[data-ndis-quote-note]');
  var errorsBox = document.querySelector('[data-ndis-errors]');
  var errorList = document.querySelector('[data-ndis-error-list]');
  var submitBtn = form.querySelector('[data-ndis-submit]');

  function selectedPlan() {
    var checked = form.querySelector('[data-ndis-plan]:checked');
    return checked ? checked.value : null;
  }

  function requireField(el, on) {
    if (!el) return;
    if (on) {
      el.setAttribute('required', '');
    } else {
      el.removeAttribute('required');
    }
  }

  function applyState() {
    var plan = selectedPlan();
    var showEmail = plan === 'Plan Managed';
    var showAgency = plan === 'NDIA (Agency) Managed';
    var showReplacement = plan === 'Plan Managed' || plan === 'NDIA (Agency) Managed';
    var showSteps = plan === 'Self Managed' || plan === 'Quote Only';
    var showCustomerEmail = plan === 'Self Managed' || plan === 'Quote Only';

    if (showEmail) {
      emailWrap.removeAttribute('hidden');
    } else {
      emailWrap.setAttribute('hidden', '');
    }
    requireField(email, showEmail);

    if (showAgency) {
      agencyWrap.removeAttribute('hidden');
    } else {
      agencyWrap.setAttribute('hidden', '');
    }
    requireField(agency, showAgency);

    if (showCustomerEmail) {
      customerEmailWrap.removeAttribute('hidden');
    } else {
      customerEmailWrap.setAttribute('hidden', '');
    }
    requireField(customerEmail, showCustomerEmail);

    if (showReplacement) {
      replacementWrap.removeAttribute('hidden');
    } else {
      replacementWrap.setAttribute('hidden', '');
    }
    requireField(replacement, showReplacement);

    if (showSteps) {
      steps.removeAttribute('hidden');
    } else {
      steps.setAttribute('hidden', '');
    }
    if (plan === 'Quote Only') {
      quoteNote.removeAttribute('hidden');
    } else {
      quoteNote.setAttribute('hidden', '');
    }
  }

  function collectInvalidMessages() {
    var msgs = [];
    var seen = {};
    var fields = form.querySelectorAll('input[data-ndis-plan], input[data-ndis-first], input[data-ndis-last], input[data-ndis-number], input[data-ndis-dob], input[data-ndis-phone], input[data-ndis-email], input[data-ndis-agency], input[data-ndis-customer-email], input[data-ndis-replacement]');
    for (var i = 0; i < fields.length; i++) {
      var el = fields[i];
      var visible = el.offsetParent !== null;
      if (!visible) continue;
      if (!el.checkValidity()) {
        var text;
        if (el.matches('[data-ndis-plan]')) {
          var legend = form.querySelector('fieldset[data-ndis-plan]') || form.querySelector('fieldset');
          legend = legend ? legend.querySelector('legend') : null;
          text = legend ? legend.textContent.replace('*', '').trim().slice(0, 80) : el.name;
          if (seen[el.name]) continue;
          seen[el.name] = true;
        } else {
          text = el.labels && el.labels[0] ? el.labels[0].textContent.replace('*', '').trim().slice(0, 80) : el.name;
        }
        msgs.push(text + ': ' + el.validationMessage);
      }
    }
    return msgs;
  }

  function showErrors(msgs) {
    errorList.innerHTML = '';
    for (var i = 0; i < msgs.length; i++) {
      var li = document.createElement('li');
      li.textContent = msgs[i];
      errorList.appendChild(li);
    }
    errorsBox.removeAttribute('hidden');
    errorsBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clearErrors() {
    errorList.innerHTML = '';
    errorsBox.setAttribute('hidden', '');
  }

  function saveAttributes(callback) {
    var plan = selectedPlan();
    var attributes = { 'NDIS Payer': 'yes', 'Plan Type': plan };

    attributes['First Name'] = form.querySelector('[data-ndis-first]').value.trim();
    attributes['Last Name'] = form.querySelector('[data-ndis-last]').value.trim();
    attributes['NDIS Participant Number'] = form.querySelector('[data-ndis-number]').value.trim();
    attributes['Date of Birth'] = form.querySelector('[data-ndis-dob]').value;
    attributes['Phone'] = phone.value.trim();
    attributes['Plan Manager Email'] = plan === 'Plan Managed' ? email.value.trim() : '';
    attributes['Agency Email'] = plan === 'NDIA (Agency) Managed' ? agency.value.trim() : '';
    attributes['Customer Email'] = (plan === 'Self Managed' || plan === 'Quote Only') ? customerEmail.value.trim() : '';
    attributes['Replacement Supports'] = (plan === 'Plan Managed' || plan === 'NDIA (Agency) Managed') && replacement.checked ? replacement.value : '';

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: attributes })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart update failed: ' + res.status);
        return res.json();
      })
      .then(function () {
        callback();
      })
      .catch(function () {
        showErrors(['We could not save your details. Please check your connection and try again.']);
        submitBtn.disabled = false;
      });
  }

  form.addEventListener('change', function (event) {
    if (event.target.matches('[data-ndis-plan]')) applyState();
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    var msgs = collectInvalidMessages();
    if (msgs.length > 0) {
      showErrors(msgs);
      return;
    }
    clearErrors();
    submitBtn.disabled = true;
    saveAttributes(function () {
      window.location = '/checkout';
    });
  });

  applyState();
})();
